/* eslint-disable no-useless-escape */
import Vue from "@/helper/initVue";

import {
  RasmusUserLogin,
  RasmusUserLoginConfig,
} from "@/features/rasmus-kids-club/users/login";

export const initRasmusUserLogin = () => {
  const el = document.getElementById("rasmus-user-login");

  if (!el) {
    return;
  }

  try {
    const dataSettings = el.getAttribute("data-settings");

    if (!dataSettings) {
      return;
    }

    const parsedSettings: RasmusUserLoginConfig = JSON.parse(dataSettings);

    new Vue({
      el,
      render: (h) =>
        h(RasmusUserLogin, {
          props: {
            settings: parsedSettings,
          },
        }),
    });
  } catch (err) {
    console.error('Failed to load module "RasmusUserLogin"');
  }
};

initRasmusUserLogin();
